function agreeCheck() {
  if ($('.js-agree-check')[0]) {
    const $check = $('.js-agree-check');
    const $btn = $('.js-agree-btn');

    if ($('.js-agree-check').prop('checked') == true) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }

    $check.on('change', function () {
      if ($('.js-agree-check').prop('checked') == true) {
        $btn.prop('disabled', false);
      } else {
        $btn.prop('disabled', true);
      }
    });
  }
}

function addItem() {
	const init = 1
	const more = 1

	$('.js-add-wrap li:nth-child(n+' + (init+1) + ')').addClass('is-hidden');

	$('.js-add-wrap').filter(function(){
		return $(this).find('li').length <= init
	}).find('.more-btn').addClass('is-hidden');

	$('.js-add-trigger').on('click',function(){
		let this_list = $(this).closest('.js-add-wrap')
		this_list.find('li:hidden').slice(0,more).removeClass('is-hidden');

		if(this_list.find('li:hidden').length == 0){
			$(this).fadeOut()
		}
	})
}

function addAddress() {
	$('.p-postal-code').blur(focusAddress);

	function focusAddress() {
		$('.p-region-id,.p-locality,.p-street-address,p-extended-address').focus();
	}
}
function leaveProductInfo() {
	$('.js-add-wrap li').each(function () {
		const radio = $(this).find('.p-form-radio');
		for (let i = 0; i < radio.length; i++) {
			if(radio.eq(i).prop('checked')) {
				$(this).closest('li').removeClass('is-hidden');
				$(this).closest('li').addClass('is-show');
			}
		}

		const input_txt = $(this).find('.p-form-input');
		for (let i = 0; i < input_txt.length; i++) {
			if(input_txt.eq(i).val() !== '') {
				$(this).closest('li').removeClass('is-hidden');
				$(this).closest('li').addClass('is-show');
			}
		}

		const input_textarea = $(this).find('.p-form-textarea');
		for (let i = 0; i < input_textarea.length; i++) {
			if(input_textarea.eq(i).val() !== '') {
				$(this).closest('li').removeClass('is-hidden');
				$(this).closest('li').addClass('is-show');
			}
		}
	})
}

function deleteProductInfo() {
	$('.js-delete-btn').on('click', function() {
		const input = $(this).closest('.p-form-product-group').find('input, textarea, select');
		input.each(function() {
			$(this).val('');
			$(this).prop('checked', false);
			$(this).garlic('destroy');
		});
		$(this).closest('.p-form-product-group').closest('li').removeClass('is-show');
		$(this).closest('.p-form-product-group').closest('li').addClass('is-hidden');
	})
}

function resetInfo() {
	$('#form-reset').on('click', function() {
		$('form').garlic('destroy');
		$('.js-agree-btn').prop('disabled', true);
		$('.js-add-wrap li:nth-child(n+2)').removeClass('is-show');
		$('.js-add-wrap li:nth-child(n+2)').addClass('is-hidden');
	})
}


//init
//---------------------------------------------------------
$(function () {
	$('form').garlic();
  agreeCheck();

	if($('.h-adr').length) {
		addAddress();
	}

	if($('.js-add-trigger').length) {
		addItem();
		leaveProductInfo();
		deleteProductInfo();
	};

	resetInfo();
});
